/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// ====================================================================================================
// 互換: HTMLにハードコードされている onchange="cartNoshiOption();" 用の no-op
// => 現在のロジックはすべて addEventListener で実装されているため、この関数は何もする必要がない。
//    ただし関数未定義のままだと change のたびに ReferenceError が出るので no-op を用意しておく。
//    本来は c_main-cart.liquid 側の onchange 属性を削除するのが望ましい (HTML改修フェーズで対応予定)
// ====================================================================================================
window.cartNoshiOption = window.cartNoshiOption || function () {};

// ====================================================================================================
// [v13.5 / Phase 5-2] v8 Focal の <product-variants> をドロワー用に移植
//
// 背景:
//   v13 の <variant-picker> はオプション変更時に Shopify から商品ページHTMLを fetch して
//   レスポンス内の自身と同じ form-id の variant-picker を探す設計。
//   ドロワーでは form-id にクライアント側サフィックス (-01, -02) が付いているため
//   fetch レスポンス側の form-id とミスマッチし、バリエーション切替がサイレント失敗する。
//
//   v8 Focal の <product-variants> はクライアント完結 (/products/HANDLE.js で全 variant データを
//   取得し、ローカルで variant を lookup) なので form-id サフィックスの影響を受けない。
//
//   そこで <product-variants> のみを v8 互換でここに復活定義し、ドロワー / ポップオーバー文脈で
//   c_product-form.liquid が <product-variants> を出力するようにする。
//   通常商品ページは v13 の <variant-picker> をそのまま使い続ける。
// ====================================================================================================
(function defineProductVariants() {
  if (window.customElements.get('product-variants')) return;

  // ProductLoader: /products/HANDLE.js を一度だけ fetch してキャッシュ (v8 移植)
  class ProductLoader {
    static load(handle) {
      if (!handle) return Promise.reject(new Error('handle required'));
      if (this._cache[handle]) return this._cache[handle];
      this._cache[handle] = fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
        .then(r => r.json());
      return this._cache[handle];
    }
  }
  ProductLoader._cache = {};

  // ProductVariants: option ラジオの change を捕まえ、対応する variant の id を hidden input に反映
  class ProductVariants extends HTMLElement {
    async connectedCallback() {
      const form = document.getElementById(this.getAttribute('form-id'));
      if (!form) return;

      // HTMLFormElement の named property access で <input name="id"> を取得
      // (form.id は通常 form の id 属性だが、子要素に name="id" がいる場合はそれを返す)
      const idInput = form.elements ? form.elements.namedItem('id') : form.id;
      if (!idInput || idInput.tagName !== 'INPUT') {
        console.warn('[product-variants] form の name="id" hidden input が見つからない');
        return;
      }
      this.masterSelector = idInput;

      // v13 c_product-form.liquid の hidden id input は初期状態 disabled なので、
      // ドロワー submit 時に variant id が送信されるよう disabled を外す
      this.masterSelector.removeAttribute('disabled');

      try {
        this.product = await ProductLoader.load(this.productHandle);
      } catch (err) {
        console.error('[product-variants] ProductLoader failed:', err);
        return;
      }
      if (!this.product || !Array.isArray(this.product.variants)) return;

      // change イベントを捕捉 (このルート要素配下のオプション input のみ)
      this.addEventListener('change', this._onOptionChanged.bind(this));

      // 初期状態のラベル ([data-bind-value]) を同期
      this._syncBoundLabels();

      // 初期 variant を masterSelector に反映 (チェック済みのラジオから)
      const initial = this._getVariantFromOptions();
      if (initial) this._selectVariant(initial.id, { silent: true });
    }

    get productHandle() { return this.getAttribute('handle'); }

    _onOptionChanged(event) {
      if (!event.target.matches('input[name^="option"], select[name^="option"]')) return;
      this._syncBoundLabels(event.target);
      const variant = this._getVariantFromOptions();
      if (variant) this._selectVariant(variant.id);
    }

    /**
     * 選択肢の値を data-bind-value で指定された要素のテキストに反映
     * (v8 互換: <span id="..."-value> の中身を更新)
     */
    _syncBoundLabels(target) {
      const inputs = target ? [target] : Array.from(this.querySelectorAll('input[name^="option"]:checked, select[name^="option"]'));
      inputs.forEach(input => {
        const bindId = input.getAttribute('data-bind-value');
        if (!bindId) return;
        const el = document.getElementById(bindId);
        if (el) el.textContent = input.value;
      });
    }

    _selectVariant(id, opts) {
      opts = opts || {};
      this.masterSelector.value = id;
      this.masterSelector.dispatchEvent(new Event('change', { bubbles: true }));
      if (opts.silent) return;

      const form = this.masterSelector.form;
      if (!form) return;
      const variant = this.product.variants.find(v => v.id === id);
      // v13 variant-picker と同じイベント名で dispatch して、画像切替などの既存 listener が反応するように
      form.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant, formId: form.id }
      }));
      form.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { variant, formId: form.id }
      }));

      // v13 の <product-meta> 内の価格は <product-rerender> 経由 (htmlFragment 差替)で更新される設計で、
      // 我々はクライアント完結なので htmlFragment を持っていない。
      // → 同ドロワー/popover 内の product-meta の価格 DOM を自前で書き換える (v8 ProductMeta 相当)
      this._updateRelatedProductMeta(variant);
    }

    /**
     * 同じドロワー / popover 内の <product-meta> の価格・在庫ラベルを variant に応じて更新
     */
    _updateRelatedProductMeta(variant) {
      if (!variant) return;
      const container = this.closest('product-rerender, quick-buy-drawer, quick-buy-popover')
        || this.closest('.quick-buy-product')
        || document.body;
      if (!container) return;
      const meta = container.querySelector('product-meta, .product-item-meta');
      if (!meta) return;

      // JPY フォーマッタ (Shopify の price は ×100 で保存されている)
      const fmt = (cents) => `¥${Math.round(cents / 100).toLocaleString('ja-JP')}`;

      // 価格表示部 (v13: .price-list > .price)
      const priceList = meta.querySelector('.price-list');
      if (priceList) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceList.innerHTML =
            `<span class="price price--highlight"><span class="visually-hidden">割引価格</span>${fmt(variant.price)}</span>` +
            `<span class="price price--compare"><span class="visually-hidden">通常価格</span>${fmt(variant.compare_at_price)}</span>`;
        } else {
          priceList.innerHTML =
            `<span class="price"><span class="visually-hidden">価格</span>${fmt(variant.price)}</span>`;
        }
      }

      // 在庫切れラベル (もしマークアップがあれば)
      const labelList = meta.querySelector('[data-product-label-list]');
      if (labelList) {
        if (!variant.available) {
          labelList.innerHTML = `<span class="label label--subdued">在庫切れ</span>`;
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const off = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          labelList.innerHTML = `<span class="label label--highlight">${off}% OFF</span>`;
        } else {
          labelList.innerHTML = '';
        }
      }
    }

    _getVariantFromOptions() {
      const options = this._getSelectedOptionValues();
      return this.product.variants.find(variant =>
        variant.options.every((value, index) => value === options[index])
      );
    }

    _getSelectedOptionValues() {
      return Array.from(this.querySelectorAll('input[name^="option"]:checked, select[name^="option"]'))
        .map(input => input.value);
    }
  }

  window.customElements.define('product-variants', ProductVariants);
})();

// 商品ページ：商品説明の後に特典表記を追加
// => sections/product-description.liquid
// ==================================================================================================== //
document.addEventListener('DOMContentLoaded', () => {
  const targetSelector = '.product-description_body';

  const insertPresentContent = (targetElement) => {
    if (!targetElement || targetElement.querySelector('.product-description_body_present')) return;

    const presentHTML = `
      <div class="product-description_body_present">
        <h3>レビュー特典</h3>
        <p>
          お名前札:ご希望の方は、このページ内の「レビュー投稿でお名前札プレゼント」
          項目の入力欄にお子様のお名前と生年月日をご記入ください。
        </p>
        <h3>お買い上げ特典</h3>
        <ol>
          <li>毛氈（もうせん）</li>
          <li>羽根はたき</li>
          <li>お手入れ用手袋</li>
          <li>磨きクロス</li>
        </ol>
      </div>
    `;

    targetElement.insertAdjacentHTML('beforeend', presentHTML);
  };

  const observer = new MutationObserver(() => {
    const targetElement = document.querySelector(targetSelector);
    if (targetElement) {
      insertPresentContent(targetElement);
      observer.disconnect(); // 一度挿入したら監視を止める
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// 商品ページ：#RedirectToCartボタン制御 ＆ 和暦変換 ＆ LIP制御
// => sections/product-description.liquid
// ==================================================================================================== //
document.addEventListener("DOMContentLoaded", function () {
  const productFormBlock = document.getElementById("productFormBlock");
  const productForm = document.querySelector("form.shopify-product-form");

  const addToCartBtn = document.getElementById("AddToCart");
  const redirectBtn = document.getElementById("RedirectToCart");

  //if (!productFormBlock || !addToCartBtn || !redirectBtn || !productForm) return;

  // ========================================
  // ボタン有効化制御
  // ========================================
  function updateButtonState() {
    const blocks = document.querySelectorAll("#productFormBlock");

    blocks.forEach((block) => {
      const addToCartBtn = block.querySelector("#AddToCart");
      const redirectBtn = block.querySelector("#RedirectToCart");

      if (!addToCartBtn && !redirectBtn) return;

      const requiredFields = block.querySelectorAll("[required]");
      let allFilled = true;

      requiredFields.forEach((el) => {
        if (el.type === "checkbox" || el.type === "radio") {
          const groupChecked = block.querySelectorAll(
            `[name="${el.name}"]:checked`,
          );
          if (groupChecked.length === 0) allFilled = false;
        } else if (el.type === "date") {
          if (!el.value || el.value.trim() === "") allFilled = false;
        } else {
          if (!el.value || el.value.trim() === "") allFilled = false;
        }
      });

      const toggleButtons = [addToCartBtn, redirectBtn];
      toggleButtons.forEach((btn) => {
        if (!btn) return;
        if (allFilled) {
          btn.classList.remove("button--ternary");
          btn.classList.add("button--primary");
          btn.removeAttribute("disabled");
        } else {
          btn.classList.remove("button--primary");
          btn.classList.add("button--ternary");
          btn.setAttribute("disabled", "disabled");
        }
      });
    });
  }

  // body全体を監視（ブロックやボタンが後から出ても対応）
  function observeFields() {
    const observer = new MutationObserver(updateButtonState);

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["required", "name"],
    });

    // 入力イベント（キャプチャリングで拾う）
    document.addEventListener("input", updateButtonState, true);
    document.addEventListener("change", updateButtonState, true);
  }

  window.addEventListener("pageshow", () => {
    updateButtonState();
    observeFields();
  });

  // ========================================
  // お名前札プレゼント制御
  // ========================================
  // [v13.4] per-block 関数として書き直し、quick-buy-drawer / quick-buy-popover で動的にロードされた
  //          新規 onamaefuda ブロックに対しても MutationObserver から setup を呼べるようにする。
  //          旧実装は document.querySelector(".product-form__onamaefuda") で最初の1つしか拾えず、
  //          ドロー型カートで「希望する」を選んでもサブUI が表示されない致命バグの原因だった (Phase 5)。
  function setupOnamaefuda(block) {
    if (!block || block.dataset.onamaefudaInitialized === 'true') return;
    block.dataset.onamaefudaInitialized = 'true';

    const flagEl = block.querySelector("#product-form__onamaefuda__flag");
    const typeWrapper = block.querySelector("#product-form__onamaefuda__item__type");
    const nameWrapper = block.querySelector("#product-form__onamaefuda__item__name");
    const dateWrapper = block.querySelector("#product-form__onamaefuda__item__date");
    const typeEl = block.querySelector("#product-form__onamaefuda__type");
    const nameEl = block.querySelector("#product-form__onamaefuda__name");
    const dateEl = block.querySelector("#product-form__onamaefuda__date");
    const noteWood = block.querySelector("#onamaefuda_note_wood");
    const noteAcryl = block.querySelector("#onamaefuda_note_acryl");
    // [v13.7 / Phase 8] dateActualEl は実 LIP `properties[お名前札のお誕生日]` の送信先 (Liquid 側で
    //   name 属性が常時静的付与済み)。resetFields でも value をクリアする必要があるため、
    //   宣言を関数頭で行い、resetFields/updateDateActual の両方から参照できるようにする。
    //   旧実装ではこの const が line 520 付近で宣言されていたため resetFields からは undefined で、
    //   結果として「希望する→bfcache 復帰→希望しない」で古い日付値が LIP に残るバグの原因となっていた。
    const dateActualEl = block.querySelector("#product-form__onamaefuda__date__actual");

    // 元の name を保存
    const originalNames = {
      type: typeEl?.getAttribute("name"),
      name: nameEl?.getAttribute("name"),
      date: dateEl?.getAttribute("name"),
    };

    // 初期化（name/required 削除, value 空, 非表示）
    function resetFields() {
      [typeEl, nameEl, dateEl].forEach((el) => {
        if (!el) return;
        el.removeAttribute("name");
        el.removeAttribute("required");
        el.value = "";
      });
      // [v13.7 / Phase 8] dateActualEl は Pattern F と同じく name 属性を静的維持しているため、
      //   removeAttribute('name') はせず、value だけクリアする。
      //   これを怠ると bfcache 復帰後に「希望しない」へ切り替えた際、LIP「お名前札のお誕生日」に
      //   前回入力の和暦/西暦日付が残って NextEngine 側まで流れてしまう (梶原さん発見の Pattern G)。
      if (dateActualEl) dateActualEl.value = "";
      [typeWrapper, nameWrapper, dateWrapper].forEach((w) => {
        if (w) w.style.display = "none";
      });
      if (noteWood) noteWood.style.display = "none";
      if (noteAcryl) noteAcryl.style.display = "none";
      updateButtonState();
    }

    // 有効化（name/required 復元, 表示）
    function activateFields() {
      if (typeEl) {
        typeEl.setAttribute("name", originalNames.type);
        typeEl.setAttribute("required", "required");
      }
      if (nameEl) {
        nameEl.setAttribute("name", originalNames.name);
        nameEl.setAttribute("required", "required");
      }
      if (dateEl) {
        dateEl.setAttribute("name", originalNames.date);
        dateEl.setAttribute("required", "required");
      }
      if (typeWrapper) typeWrapper.style.display = "block";
      if (nameWrapper) nameWrapper.style.display = "block";
      if (dateWrapper) dateWrapper.style.display = "block";
      updateNotes();
      updateButtonState();
    }

    // お名前札の種類に応じて注意文切り替え
    function updateNotes() {
      if (!typeEl) return;
      if (noteWood)
        noteWood.style.display = typeEl.value.includes("木札")
          ? "block"
          : "none";
      if (noteAcryl)
        noteAcryl.style.display = typeEl.value.includes("アクリル札")
          ? "block"
          : "none";
    }

    // flag の値によって分岐
    function handleFlagChange() {
      if (!flagEl) return;
      if (flagEl.value === "希望する") {
        activateFields();
      } else {
        resetFields();
      }
    }

    // 初期化
    resetFields();
    if (flagEl) flagEl.addEventListener("change", handleFlagChange);
    if (typeEl) typeEl.addEventListener("change", updateNotes);
    handleFlagChange(); // ロード時の flag 初期値が「希望する」なら適用

    // [v13.5+] お名前札のお誕生日 sync (可視 date input → 隠し dateActual input)
    // 旧 handleOnamaefudaDate は document.getElementById 依存で、ドロワー内に動的にロードされた
    // onamaefuda には結びつかず、お誕生日値がカートに継承されなかった。
    // setupOnamaefuda は MutationObserver 経由で動的 block にも呼ばれるので、ここに per-block で実装。
    // [v13.7 / Phase 8] dateActualEl の const 宣言は関数頭 (typeEl 等と同じ位置) に移動済み。
    function updateDateActual() {
      if (!typeEl || !dateEl || !dateActualEl) return;
      const typeVal = typeEl.value || "";
      if (!dateEl.value) {
        dateActualEl.value = "";
        return;
      }
      if (typeVal.includes("アクリル札")) {
        dateActualEl.value = dateEl.value; // 西暦そのままコピー
      } else if (typeVal.includes("木札")) {
        dateActualEl.value = toWareki(dateEl.value); // 和暦に変換
      } else {
        dateActualEl.value = "";
      }
    }
    if (dateEl) dateEl.addEventListener("change", updateDateActual);
    if (typeEl) typeEl.addEventListener("change", updateDateActual);
    // 初期値もシンク (bfcache 復帰や初期 selected option がある場合に備えて)
    updateDateActual();

    // pageshow は通常の商品ページ上の (DOMContentLoaded 時から存在する) onamaefuda block でのみ意味があるので、
    // MutationObserver 経由で動的に来た block には登録しない。
    // (drawer は閉じる/開く毎に新規生成・破棄されるので pageshow を待つ意味が無い)
    if (!block.closest('quick-buy-drawer, quick-buy-popover')) {
      // [v13.2] bfcache 復帰時は破壊的な resetFields() を行わない。
      window.addEventListener("pageshow", (e) => {
        if (e.persisted) return; // bfcache 復帰: 何もしない
        resetFields();
        handleFlagChange();
      });
    }
  }

  // 初期ロード時の onamaefuda block (商品ページ本体) をセットアップ
  document.querySelectorAll(".product-form__onamaefuda").forEach(setupOnamaefuda);

  // [v13.4] quick-buy-drawer / quick-buy-popover から動的にロードされた onamaefuda block を捕捉
  const onamaefudaObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(".product-form__onamaefuda")) {
          setupOnamaefuda(node);
        }
        node.querySelectorAll?.(".product-form__onamaefuda").forEach(setupOnamaefuda);
      }
    }
  });
  onamaefudaObserver.observe(document.body, { childList: true, subtree: true });

  // ========================================
  // 西暦を和暦 (令和/平成/昭和) に変換
  // ========================================
  function toWareki(dateStr) {
    if (!dateStr) return "";
    const [y, m, d] = dateStr.split("-").map((num) => parseInt(num, 10));
    const eraTable = [
      { name: "令和", start: [2019, 5, 1], base: 2018 },
      { name: "平成", start: [1989, 1, 8], base: 1988 },
      { name: "昭和", start: [1926, 12, 25], base: 1925 },
    ];
    const dateNum = y * 10000 + m * 100 + d;
    for (const era of eraTable) {
      const [sy, sm, sd] = era.start;
      const startNum = sy * 10000 + sm * 100 + sd;
      if (dateNum >= startNum) {
        const year = y - era.base;
        const jpYear = year === 1 ? "元" : numToKanji(year);
        return `${era.name}${jpYear}年${numToKanji(m)}月${numToKanji(d)}日`;
      }
    }
    return `${y}年${m}月${d}日`; // fallback
  }

  // 生年月日の数字を漢数字へ変換
  function numToKanji(num) {
    const kanjiDigits = [
      "〇",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六",
      "七",
      "八",
      "九",
    ];
    if (num === 10) return "十";
    if (num < 10) return kanjiDigits[num];
    if (num < 20) return "十" + (num % 10 !== 0 ? kanjiDigits[num % 10] : "");
    if (num < 30) return "二十" + (num % 10 !== 0 ? kanjiDigits[num % 10] : "");
    if (num < 40) return "三十" + (num % 10 !== 0 ? kanjiDigits[num % 10] : "");
    return num; // 30日までしかないのでこれでOK
  }

  // ========================================
  // 名入れ商品（naire）の日付を和暦に変換
  // ========================================
  function handleNaireDate(root = document) {
    // root 内の全ての #product-form__naire__date を対象にする
    const dateInputs = root.querySelectorAll("#product-form__naire__date");
    dateInputs.forEach((naireDate) => {
      const form = naireDate.closest(".product-form"); // 対応するフォームを特定
      if (!form) return;

      const naireDateActual = form.querySelector(
        "#product-form__naire__date__actual",
      );
      if (!naireDateActual) return;

      // 既に初期化済みならスキップ
      if (naireDate.dataset.initialized === "true") return;

      // イベント登録
      naireDate.addEventListener("change", () => {
        naireDateActual.value = toWareki(naireDate.value);
      });

      // 初期化フラグ
      naireDate.dataset.initialized = "true";
    });
  }

  // ========================================
  // MutationObserver: .product-form が追加されたときに処理
  // ========================================
  const naireObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;

        // 追加されたノードが .product-form ならその中を処理
        if (node.matches?.(".product-form")) {
          handleNaireDate(node);
        }

        // 子孫に .product-form がある場合も処理
        const forms = node.querySelectorAll?.(".product-form") || [];
        forms.forEach((form) => handleNaireDate(form));
      }
    }
  });

  naireObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // ========================================
  // お名前札（onamaefuda）の日付を処理
  // ========================================
  function handleOnamaefudaDate() {
    const typeSelect = document.getElementById(
      "product-form__onamaefuda__type",
    );
    const dateInput = document.getElementById("product-form__onamaefuda__date");
    const dateActual = document.getElementById(
      "product-form__onamaefuda__date__actual",
    );
    if (!typeSelect || !dateInput || !dateActual) return;

    function updateOnamaefudaActual() {
      const typeVal = typeSelect.value || "";
      if (!dateInput.value) {
        dateActual.value = "";
        return;
      }
      if (typeVal.includes("アクリル札")) {
        dateActual.value = dateInput.value; // 西暦そのままコピー
      } else if (typeVal.includes("木札")) {
        dateActual.value = toWareki(dateInput.value); // 和暦に変換
      } else {
        dateActual.value = "";
      }
    }

    typeSelect.addEventListener("change", updateOnamaefudaActual);
    dateInput.addEventListener("change", updateOnamaefudaActual);
  }

  handleNaireDate();
  handleOnamaefudaDate();

  window.addEventListener("pageshow", () => {
    handleNaireDate();
    handleOnamaefudaDate();
  });

  // ========================================
  // popover/drawer内のformのidに連番付与
  // => 1ページ内に同一商品が複数ある場合の動作保証
  // ========================================
  // ページ全体での通し番号
  let globalCounter = 1;

  function updateProductFormIds(productFormBlock) {
    if (!productFormBlock) return;

    const elements = productFormBlock.querySelectorAll(
      "[form-id], [form], form[id]",
    );

    elements.forEach((el) => {
      const suffix = `-${String(globalCounter).padStart(2, "0")}`;

      // form-id 属性
      if (el.hasAttribute("form-id")) {
        el.setAttribute("form-id", el.getAttribute("form-id") + suffix);
      }

      // form 属性
      if (el.hasAttribute("form")) {
        el.setAttribute("form", el.getAttribute("form") + suffix);
      }

      // <form> タグの id 属性のみ
      if (el.tagName === "FORM" && el.hasAttribute("id")) {
        el.setAttribute("id", el.getAttribute("id") + suffix);
      }
    });

    // [v13.4] form-id サフィックス変更後に variant-picker を再初期化
    // variant-picker は connectedCallback で form-id を内部キャッシュするため、
    // suffix 適用後に DOM 再接続して connectedCallback を再発火させる必要がある。
    // (これを行わないと、ドロー型カートでバリエーション切り替えが反映されないバグが発生)
    productFormBlock.querySelectorAll("variant-picker").forEach((vp) => {
      const parent = vp.parentNode;
      const next = vp.nextSibling;
      if (!parent) return;
      parent.removeChild(vp);          // disconnectedCallback 発火
      parent.insertBefore(vp, next);   // connectedCallback 再発火 → 新 form-id を読む
    });

    // [v13.4] variant-picker.selectCombination の monkey-patch
    // ============================================================================================
    // selectCombination 内の以下のコードは、サフィックス付き form-id では動かない：
    //   const newVariantPicker = deepQuerySelector(newContent,
    //     `${this.tagName}[form-id="${this.getAttribute("form-id")}"]`);
    //
    // 理由: newContent は Shopify の通常の商品ページHTMLを fetch したもの。
    //       その中の variant-picker は ORIGINAL form-id (サフィックス無し) を持つ。
    //       現要素の form-id は "-02" 付きなので、deepQuerySelector が null を返し、
    //       直後の null.querySelector で例外 (async で握りつぶされ silent failure)。
    //
    // 対策: selectCombination 実行中だけ form-id を一時的にサフィックス無しに戻す。
    //       deepQuerySelector が成功すれば、続く form.id.value 代入や CustomEvent 発火が正常に動く。
    //       終了後に form-id を suffix 付きへ戻すので delegate selector との整合も維持される。
    // ============================================================================================
    if (!window.__variantPickerSuffixPatched) {
      const VP = window.customElements.get("variant-picker");
      if (VP && VP.prototype && VP.prototype.selectCombination) {
        const original = VP.prototype.selectCombination;
        VP.prototype.selectCombination = async function (args) {
          const currentFormId = this.getAttribute("form-id") || "";
          const suffixMatch = currentFormId.match(/-(\d{2})$/);
          if (!suffixMatch) {
            return original.call(this, args);
          }
          const originalFormId = currentFormId.slice(0, -suffixMatch[0].length);
          this.setAttribute("form-id", originalFormId);
          try {
            return await original.call(this, args);
          } finally {
            this.setAttribute("form-id", currentFormId);
          }
        };
        window.__variantPickerSuffixPatched = true;
      }
    }

    // ブロック単位で counter をインクリメント
    globalCounter++;
  }

  // MutationObserver で後から追加された #productFormBlock を監視
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue; // element 以外無視

        // 直接追加された #productFormBlock
        if (
          node.id === "productFormBlock" &&
          (node.closest("quick-buy-popover") ||
            node.closest("quick-buy-drawer"))
        ) {
          updateProductFormIds(node);
        } else {
          // node 配下にある #productFormBlock
          node.querySelectorAll("#productFormBlock").forEach((block) => {
            if (
              block.closest("quick-buy-popover") ||
              block.closest("quick-buy-drawer")
            ) {
              updateProductFormIds(block);
            }
          });
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // ========================================
  // 購入手続きボタン（#RedirectToCart）挙動
  // ========================================
  if (redirectBtn) {
    redirectBtn.addEventListener("click", async function (e) {
      e.preventDefault();
      const formData = new FormData(productForm);

      document.querySelectorAll('[name^="properties["]').forEach((el) => {
        if ((el.type === "checkbox" || el.type === "radio") && !el.checked)
          return;
        if (el.value !== undefined && el.value !== null && el.value !== "") {
          formData.set(el.name, el.value);
        }
      });

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (!response.ok) {
          const error = await response.json();
          console.error("カート追加エラー:", error);
          alert("カートに商品を追加できませんでした。");
          return;
        }
        window.location.href = "/cart";
      } catch (err) {
        console.error("通信エラー:", err);
        alert("カート追加に失敗しました。");
      }
    });
  }
});

// ====================================================================================================
// カート熨斗オプション - Cart Attributes / delivery_time 同期
// => sections/c_main-cart.liquid
//
// 【v13.1 改修内容（2026-05-15）】
// (P0-1) updateNoshiSummary を request-id 方式で書き直し、/cart.js fetch の resolve 順逆転による
//        textarea 上書きを根絶（#5384「別人名が入る」の根因対策）。
// (P0-2) フォーム submit を一旦止めて、最新の delivery_time を確定してから本送信する submit ゲートを設置
//        （#4132「贈り主名欠落」の根因対策）。
// (P0-3) テキスト入力に input イベントも併用し、blur 前 submit のケースで取りこぼさないようにした。
// (P1-4) 連名追加ボタンを type="button" にして JS 失敗時の意図しない submit を防止。
// (P1-7) pageshow ハンドラをこのブロック内に1本化。
//
// 【v13.2 改修内容（2026-05-28）】
// (P0-4) pageshow に bfcache 復帰判定を追加。
//        実機テスト #6377/#6371/#6366 で「ブラウザバック後に連名入力 UI ごとクリア」が観測された。
//        event.persisted === true（= bfcache 復帰）の場合は、ブラウザ復元状態を尊重して
//        破壊的な初期化を一切行わず、軽量な再同期（delivery_time 再生成と validation 更新）のみ実施。
//
// 【v13.3 改修内容（2026-06-02）】
// (P0-5) 非 bfcache 復帰でも連名 UI が失われる問題を解消。
//        CLI dev サーバー（localhost）やデスクトップ Chrome / Android Chrome では bfcache が
//        無効化されることが多く、その場合ブラウザバックは「完全なフレッシュロード」となる。
//        Shopify の cart.attributes には連名値が保存されているが、c_main-cart.liquid は
//        連名 input を <input value=""> でハードコードしており、Liquid が cart 属性を反映していない。
//        → JS 側で cart.attributes['贈り主名の表記(2人目)'] を読み、連名 UI を再構築する。
//        この処理は bfcache が効くケースでは isAdditionalNameVisible ガードでスキップされる。
// ====================================================================================================
document.addEventListener('DOMContentLoaded', () => {
  // -------------------------------
  // DOM要素の取得
  // -------------------------------
  const noshiFlag = document.getElementById('product-form__noshi__flag');

  // [GUARD] 熨斗フォームが無いページ(=カート以外)では以降の処理を一切実行しない。
  // 旧コードは addButton.querySelector('span') 等で null 参照例外を投げていた。
  if (!noshiFlag) return;

  const noshiOmotegaki = document.getElementById('product-form__noshi__omotegaki');
  const noshiOmotegakiContent = document.getElementById('product-form__noshi__omotegaki-content');
  const noshiName = document.getElementById('product-form__noshi__name');
  const noshiNameContent = document.getElementById('product-form__noshi__name-content');
  const additionalNameWrapper = document.getElementById('product-form__noshi__item__additional-name');
  const additionalNameInput = document.getElementById('product-form__noshi__additional-name');
  const addButtonWrapper = document.getElementById('product-form__noshi__item__name-add-button');
  const addButton = document.getElementById('product-form__noshi__name-add-button');
  const addButtonText = addButton ? addButton.querySelector('span') : null;
  const combinedTextarea = document.getElementById('cart__attributes-combined-text');
  const validateElement = document.getElementById('cart__validate-name');
  const messageElement = document.querySelectorAll('.cart__validate-name-and-date');
  const checkbox = document.getElementById('cart__validate-name-checked');
  const submitButton = document.querySelector('.cart__checkout-button');
  const cartForm = submitButton ? submitButton.closest('form') : null;

  let isAdditionalNameVisible = false;

  // [FIX P1-4] 連名追加ボタンを type="button" 化。
  // 旧 HTML では type 属性が無く、フォーム内のデフォルトが type="submit" だった。
  // JS バインドが失敗した瞬間にクリックされるとフォームが submit される事故が起きうるため明示する。
  if (addButton) addButton.type = 'button';

  // -------------------------------
  // 汎用関数
  // -------------------------------
  const toggleDisplay = (id, show) => {
    const el = document.getElementById(id);
    if (el) el.style.display = show ? '' : 'none';
  };

  const toggleRequired = (element, required) => {
    if (!element) return;
    required ? element.setAttribute('required', '') : element.removeAttribute('required');
  };

  // -------------------------------
  // 熨斗オプションの表示制御
  // -------------------------------
  function updateNoshiOptions() {
    const flagValue = noshiFlag.value;
    const omotegakiValue = noshiOmotegaki.value;
    const nameValue = noshiName.value;

    if (flagValue === '要') {
      toggleDisplay('product-form__noshi__item__omotegaki', true);
      toggleRequired(noshiOmotegaki, true);

      if (omotegakiValue === 'その他') {
        toggleDisplay('product-form__noshi__item__omotegaki-content', true);
        toggleRequired(noshiOmotegakiContent, true);
      } else {
        noshiOmotegakiContent.value = '';
        toggleDisplay('product-form__noshi__item__omotegaki-content', false);
        toggleRequired(noshiOmotegakiContent, false);
      }

      if (omotegakiValue) {
        toggleDisplay('product-form__noshi__item__name', true);
        toggleRequired(noshiName, true);

        if (nameValue === '記名あり') {
          toggleDisplay('product-form__noshi__item__name-content', true);
          toggleRequired(noshiNameContent, true);
        } else {
          noshiNameContent.value = '';
          toggleDisplay('product-form__noshi__item__name-content', false);
          toggleRequired(noshiNameContent, false);
        }
      } else {
        toggleDisplay('product-form__noshi__item__name', false);
        toggleDisplay('product-form__noshi__item__name-content', false);
      }
    } else {
      [noshiOmotegaki, noshiOmotegakiContent, noshiName, noshiNameContent].forEach(el => { if (el) el.value = ''; });
      toggleRequired(noshiOmotegaki, false);
      toggleRequired(noshiOmotegakiContent, false);
      toggleRequired(noshiName, false);
      toggleRequired(noshiNameContent, false);

      toggleDisplay('product-form__noshi__item__omotegaki', false);
      toggleDisplay('product-form__noshi__item__omotegaki-content', false);
      toggleDisplay('product-form__noshi__item__name', false);
      toggleDisplay('product-form__noshi__item__name-content', false);

      toggleAdditionalName(false);
      if (addButtonWrapper) addButtonWrapper.style.display = 'none';
    }
  }

  function toggleAdditionalName(show) {
    isAdditionalNameVisible = show;

    if (show) {
      if (addButtonText) addButtonText.textContent = '− 送り主名の連名をやめる';
      if (additionalNameWrapper) additionalNameWrapper.classList.add('open');
      if (additionalNameInput) {
        // [v13.6 / Phase 6 パターン F] name 属性は Liquid 側で常時静的付与済み (c_main-cart.liquid)。
        // ここでの動的代入は後方互換のため残す (既存テーマでも動くように) が冪等。
        if (!additionalNameInput.hasAttribute('name')) {
          additionalNameInput.name = 'attributes[贈り主名の表記(2人目)]';
        }
        toggleRequired(additionalNameInput, true);
      }
    } else {
      if (addButtonText) addButtonText.textContent = '＋ 送り主名を連名にする';
      if (additionalNameWrapper) additionalNameWrapper.classList.remove('open');
      if (additionalNameInput) {
        // [v13.6 / Phase 6 パターン F] 連名 OFF でも name 属性は維持する。
        // 旧実装は removeAttribute('name') で form submit から除外していたため、
        // Shopify は cart.attributes['贈り主名の表記(2人目)'] を更新せず、古い値が残留 → 差分検知警告。
        // 修正: value だけクリアして name は残す。空値が POST されることで Shopify が attribute を空に上書きしクリア。
        // (梶原さん談: カートアトリビュート仕様、クリアは空値 POST 必須)
        toggleRequired(additionalNameInput, false);
        additionalNameInput.value = '';
      }
    }
  }

  // ====================================================================================================
  // [FIX P0-5 / v13.3] cart.attributes から熨斗 UI 全体を復元する
  //
  // 背景：
  //   c_main-cart.liquid の熨斗フォーム全フィールドが Liquid 側で cart.attributes を反映していない：
  //     - 各 select は <option value="" selected disabled>選択してください</option> で常に default 選択
  //     - 各 input は <input value=""> でハードコード
  //     - 連名 wrapper の visibility は JS の .open クラスに依存
  //
  //   bfcache が効くケース（モバイル Safari 等）はブラウザが DOM 全体を復元するので OK だが、
  //   bfcache が効かないケース（デスクトップ Chrome / Android Chrome / localhost dev）では
  //   ブラウザバック後に熨斗 UI 全体が初期状態（空）に戻ってしまう。
  //
  //   このため JS 側で /cart.js を読み、Shopify に保存されている cart.attributes から
  //   熨斗フィールド一式を再構築する。既に値が入っているフィールドは触らない
  //   （bfcache 復帰時やユーザー入力中の値を破壊しないため）。
  // ====================================================================================================
  async function restoreAdditionalNameFromCart() {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      const attrs = cart && cart.attributes;
      if (!attrs) return;

      // ヘルパー: select が空なら指定値で復元 (該当 option が存在する場合のみ)
      const restoreSelect = (el, value) => {
        if (!el || !value || el.value) return false;
        const opt = Array.from(el.options).find(o => o.value === value);
        if (!opt) return false;
        el.value = value;
        return true;
      };
      // ヘルパー: input が空なら指定値で復元
      const restoreInput = (el, value) => {
        if (!el || value === undefined || value === null || el.value) return false;
        el.value = value;
        return true;
      };

      // 主フィールド復元 (既値があれば skip)
      let restored = false;
      if (restoreSelect(noshiFlag, attrs['熨斗（のし）'])) restored = true;
      if (restoreSelect(noshiOmotegaki, attrs['表書き'])) restored = true;
      if (restoreInput(noshiOmotegakiContent, attrs['表書きの表記'])) restored = true;
      if (restoreSelect(noshiName, attrs['贈り主名'])) restored = true;
      if (restoreInput(noshiNameContent, attrs['贈り主名の表記'])) restored = true;

      // 主フィールドが復元された場合、表示制御を再実行
      if (restored) {
        updateNoshiOptions();
      }

      // 連名復元: 記名あり かつ wrapper 未 open の場合のみ
      const additional = attrs['贈り主名の表記(2人目)'];
      if (additional && additionalNameInput && !isAdditionalNameVisible && noshiName && noshiName.value.includes('記名あり')) {
        if (addButtonWrapper) addButtonWrapper.style.display = 'block';
        toggleAdditionalName(true);
        additionalNameInput.value = additional;
      }

      // 記名あり が選択されている場合は連名ボタンを表示
      if (noshiName && noshiName.value.includes('記名あり') && addButtonWrapper) {
        addButtonWrapper.style.display = 'block';
      }

      // textarea と validation を最終的に再同期
      scheduleUpdateNoshiSummary({ immediate: true });
      validateAll();
    } catch (err) {
      console.error('cart attributes 復元失敗:', err);
    }
  }

  // ====================================================================================================
  // delivery_time 同期エンジン（v13.1 で全面リライト）
  //
  // 旧実装の問題：
  //   - updateNoshiSummary() が同期的に attrText をスナップショットしたあと fetch('/cart.js') を非同期で
  //     起動し、その then 内で textarea に書き込んでいた。
  //   - 短時間に複数回 change が起きると複数の fetch が並走し、ネットワーク往復順が逆転すると
  //     「古いスナップショットで上書き」される（= #5384 の正体）。
  //
  // 新実装：
  //   - すべての書き込み試行に単調増加 ID (syncRequestSeq) を払い出す。
  //   - fetch resolve 後に「自分が最新 ID か」を毎回確認し、古いリクエストは textarea に書き込まない。
  //   - debounce(150ms) で連続入力中の無駄な fetch を抑制。
  //   - flushUpdateNoshiSummary() は pending debounce を強制発火させ、Promise を返すので
  //     submit ハンドラから await できる。
  // ====================================================================================================
  let syncRequestSeq = 0;          // 最新の発行 ID
  let pendingDebounce = null;      // 進行中の debounce タイマー
  let inFlight = Promise.resolve(); // 最後に起動した sync の Promise

  function buildAttrText() {
    const fields = document.querySelectorAll('[name^="attributes["]');
    let attrText = '';
    fields.forEach(field => {
      const match = field.name.match(/attributes\[(.*?)\]/);
      const key = match?.[1] || '';
      const val = (field.value || '').trim();
      if (key && key !== 'delivery_time' && val) {
        attrText += `${key}●${val}\n`;
      }
    });
    return attrText.trim() ? `${attrText.trim()}\nカートの追加情報` : '';
  }

  function buildProductInfo(cart) {
    let productInfo = '';
    cart.items.forEach((item, index) => {
      const properties = item.properties || {};
      const keys = Object.keys(properties).filter(k => properties[k]);

      if (keys.length > 0) {
        const num = index + 1;
        let line = `商品${num}${item.product_title}`;

        if (item.variant_title && item.variant_title !== 'Default Title') {
          line += ` - ${item.variant_title}`;
        }

        productInfo += line;

        keys.forEach(key => {
          productInfo += `\n商品${num}${key}★${properties[key]}`;
        });

        productInfo += `商品${num}\n`;
      }
    });
    return productInfo.trim() ? `${productInfo.trim()}\n商品の追加情報` : '';
  }

  async function performSync(myId) {
    // 1) 属性スナップショット (同期) — この時点で最新の DOM 値を捕捉
    const formattedAttr = buildAttrText();

    try {
      // 2) /cart.js でラインアイテムプロパティを取得 (非同期)
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await response.json();

      // 3) ★ 古いリクエストは破棄 (race 防御の本丸)
      if (myId !== syncRequestSeq) return;

      const formattedProducts = buildProductInfo(cart);
      const result = [formattedProducts, formattedAttr].filter(Boolean).join('\n\n');

      // 4) 書き込み直前にも再チェック (await の間に新しいリクエストが入っている可能性)
      if (myId !== syncRequestSeq) return;

      if (combinedTextarea) combinedTextarea.value = result;
    } catch (err) {
      console.error('カート情報取得エラー:', err);
    }
  }

  // 通常用：debounce してから実行 (連続入力で fetch が大量に走るのを防ぐ)
  function scheduleUpdateNoshiSummary({ immediate = false, debounceMs = 150 } = {}) {
    clearTimeout(pendingDebounce);
    const fire = () => {
      const myId = ++syncRequestSeq;
      inFlight = performSync(myId);
    };
    if (immediate) {
      fire();
    } else {
      pendingDebounce = setTimeout(fire, debounceMs);
    }
    return inFlight;
  }

  // 送信時用：debounce を即座に解除し、確実に最新値で textarea を更新してから resolve
  async function flushUpdateNoshiSummary() {
    clearTimeout(pendingDebounce);
    const myId = ++syncRequestSeq;
    await performSync(myId);
  }

  // -------------------------------
  // 入力チェックとボタン有効化
  // -------------------------------
  function normalizeDate(value) {
    if (!value) return '';
    let v = value.trim();

    // 西暦パターン（2025-09-20, 2025/9/20, 2025年9月20日）
    // -----------------------------------
    if (/^\d{4}/.test(v)) {
      v = v.replace(/[年月日.\-\/]/g, '');
      return v;
    }

    // 和暦パターン（例: 令和七年九月二十日）
    // -----------------------------------
    const eraMap = {
      '令和': 2018, // +年数
      '平成': 1988,
      '昭和': 1925,
      '大正': 1911,
      '明治': 1867
    };

    let era = '';
    let yearNum = '';
    let monthNum = '';
    let dayNum = '';

    // 元号判定
    for (const e in eraMap) {
      if (v.includes(e)) {
        era = e;
        break;
      }
    }

    if (era) {
      // 年
      const yearMatch = v.match(new RegExp(`${era}(.+?)年`));
      if (yearMatch) {
        yearNum = convertKanjiNumber(yearMatch[1]);
        if (yearNum === 1) {
          // 元年は1年
          yearNum = 1;
        }
      }

      // 月
      const monthMatch = v.match(/([〇一二三四五六七八九十\d]+)月/);
      if (monthMatch) {
        monthNum = convertKanjiNumber(monthMatch[1]);
      }

      // 日
      const dayMatch = v.match(/([〇一二三四五六七八九十\d]+)日/);
      if (dayMatch) {
        dayNum = convertKanjiNumber(dayMatch[1]);
      }

      const yyyy = eraMap[era] + yearNum;
      const mm = String(monthNum).padStart(2, '0');
      const dd = String(dayNum).padStart(2, '0');
      return `${yyyy}${mm}${dd}`;
    }

    return v.replace(/\D/g, ''); // fallback
  }

  // 漢数字を数値に変換（簡易対応）
  function convertKanjiNumber(kanji) {
    const map = { '〇': 0, '一': 1, '二': 2, '三': 3, '四': 4, '五': 5, '六': 6, '七': 7, '八': 8, '九': 9, '十': 10 };
    if (!kanji) return 0;

    // すでに数字ならそのまま
    if (/^\d+$/.test(kanji)) return parseInt(kanji, 10);

    let num = 0;
    if (kanji.length === 1) {
      return map[kanji] || 0;
    }

    // 二十 → 20, 二十一 → 21
    if (kanji.includes('十')) {
      const parts = kanji.split('十');
      const tens = parts[0] ? (map[parts[0]] || 1) : 1; // "十" → 10
      const ones = parts[1] ? (map[parts[1]] || 0) : 0;
      num = tens * 10 + ones;
      return num;
    }

    return map[kanji] || 0;
  }

  function validateCartNames() {
    const nameValues = Array.from(document.querySelectorAll('.cart-name-property'))
      .map(el => el.dataset.value.trim())
      .filter(Boolean);

    const dateValues = Array.from(document.querySelectorAll('.cart-date-property'))
      .map(el => normalizeDate(el.dataset.value))
      .filter(Boolean);

    let nameMismatch = false;
    let dateMismatch = false;

    // 名前チェック
    if (nameValues.length >= 2 && !nameValues.every(val => val === nameValues[0])) {
      nameMismatch = true;
    }

    // 生年月日チェック
    if (dateValues.length >= 2 && !dateValues.every(val => val === dateValues[0])) {
      dateMismatch = true;
    }

    // メッセージ切り替え
    let message = '';
    if (nameMismatch && dateMismatch) {
      message = 'お名前表記と生年月日';
    } else if (nameMismatch) {
      message = 'お名前表記';
    } else if (dateMismatch) {
      message = '生年月日';
    }

    // .cart__validate-name-and-dateにメッセージを反映
    messageElement.forEach(el => {
      el.textContent = message;
    });

    if (message) {
      if (validateElement) validateElement.classList.remove('is-hidden');
      if (checkbox) checkbox.required = true;
      if (checkbox && !checkbox.checked && submitButton) submitButton.disabled = true;
      return true;
    }

    if (validateElement) validateElement.classList.add('is-hidden');
    if (checkbox) checkbox.required = false;
    return false;
  }

  function validateRecapRequiredFields() {
    const required = document.querySelectorAll('.cart__recap input[required], .cart__recap select[required], .cart__recap textarea[required]');
    return Array.from(required).every(field => {
      if (['checkbox', 'radio'].includes(field.type)) {
        return field.checked;
      }
      return field.value.trim() !== '';
    });
  }

  function validateAll() {
    const needsConsent = validateCartNames();
    const allValid = validateRecapRequiredFields();

    if (submitButton) {
      submitButton.disabled = !allValid || (needsConsent && !checkbox.checked);
    }
  }

  // -------------------------------
  // イベント設定
  // -------------------------------
  const allNoshiFields = [noshiFlag, noshiOmotegaki, noshiOmotegakiContent, noshiName, noshiNameContent, additionalNameInput];
  allNoshiFields.forEach(el => {
    if (!el) return;
    // change: select は変更時、テキスト input は blur 時に発火
    el.addEventListener('change', () => {
      updateNoshiOptions();
      scheduleUpdateNoshiSummary();
      validateAll();
    });
    // [FIX P0-3] テキスト input には input イベントも併用。
    // 旧コードは change のみで blur 待ちだったため、ユーザーが入力後すぐ submit を押すと
    // change が間に合わず stale 値が POST されるリスクがあった。
    if (el.tagName === 'INPUT' && (el.type || '').toLowerCase() === 'text') {
      el.addEventListener('input', () => {
        // input ではフォーム構造ロジック (updateNoshiOptions) は走らせない
        // (キーストロークごとに value をクリアしうるため)。delivery_time の同期だけ行う。
        scheduleUpdateNoshiSummary();
        validateAll();
      });
    }
  });

  noshiName.addEventListener('change', () => {
    if (noshiName.value.includes('記名あり')) {
      if (addButtonWrapper) addButtonWrapper.style.display = 'block';
    } else {
      if (addButtonWrapper) addButtonWrapper.style.display = 'none';
      toggleAdditionalName(false);
    }
  });

  if (addButton) {
    addButton.addEventListener('click', e => {
      e.preventDefault();
      toggleAdditionalName(!isAdditionalNameVisible);
      // 連名トグルは即時反映したいので immediate
      scheduleUpdateNoshiSummary({ immediate: true });
      validateAll();
    });
  }

  if (checkbox) checkbox.addEventListener('change', validateAll);

  document.querySelectorAll('.cart__recap input[required], .cart__recap select[required], .cart__recap textarea[required]').forEach(field => {
    field.addEventListener('input', validateAll);
    field.addEventListener('change', validateAll);
  });

  // ====================================================================================================
  // [FIX P0-2] Submit ゲート
  //   submit を一旦止め、必ず flushUpdateNoshiSummary() の完了を待ってから本送信する。
  //   これにより「ユーザーが最後の文字を入力した直後にチェックアウトを押した」ケースでも
  //   textarea に最新値が確定された状態で POST されることを保証する。
  //
  //   form.submit() は submit イベントを発火させないため、このリスナーが再帰せず安全。
  //   万一 fetch に失敗しても (catch して) 送信自体は通す = フェイルオープン
  //   (delivery_time が空のまま通っても差分検知システムが拾える)。
  // ====================================================================================================
  if (cartForm) {
    let isFlushing = false;
    cartForm.addEventListener('submit', async (e) => {
      if (isFlushing) return; // 二重実行ガード
      e.preventDefault();
      isFlushing = true;

      // フォーカス中の text input が input イベントの debounce 中なら、
      // 強制的に blur して change を発火させる。
      // (大半のケースは submit クリック自体が blur を引き起こすが念のため)
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        try { document.activeElement.blur(); } catch (_) { /* noop */ }
      }

      if (submitButton) submitButton.disabled = true;

      try {
        await flushUpdateNoshiSummary();
      } catch (err) {
        console.error('delivery_time 同期に失敗（フェイルオープンで送信は続行）:', err);
      }

      // form.submit() は submit イベントを再発火しないので、このリスナーは再入しない
      cartForm.submit();
    });
  }

  // -------------------------------
  // 初期実行
  // -------------------------------
  updateNoshiOptions();
  scheduleUpdateNoshiSummary({ immediate: true });
  validateAll();

  // [FIX P0-5 / v13.3] cart.attributes から連名 UI を復元
  // 初回ロード時 / 非 bfcache 復帰時はサーバー側に保存された連名値を JS で再構築する必要がある
  // (Liquid テンプレートが連名 input の value をハードコード "" にしているため)
  restoreAdditionalNameFromCart();

  // 記名あり が復元されている場合は連名ボタンも表示する
  // (initial run では change イベントが発火しないので、明示的にチェック)
  if (noshiName.value.includes('記名あり')) {
    if (addButtonWrapper) addButtonWrapper.style.display = 'block';
  }

  // ====================================================================================================
  // ブラウザバック時にも実行 (pageshow 一本化)
  //
  // 【v13.2 改修内容（2026-05-28）】
  // (P0-4) bfcache 復帰判定を追加。
  //        実機テスト #6377/#6371/#6366 で「ブラウザバック後に連名入力 UI ごとクリア」が観測された。
  //        原因：bfcache 復帰時はブラウザがフォーム値・属性をすでに完全復元しているのに、
  //        旧 pageshow ハンドラが無条件で updateNoshiOptions() / toggleAdditionalName(false) を呼んで
  //        値を「上から塗り直し → 条件次第で消去」していた。
  //
  //        event.persisted === true（= bfcache 復帰）の場合は、ブラウザ復元状態を尊重して
  //        破壊的な初期化を一切行わず、軽量な再同期（delivery_time の再生成と validation 更新）のみ実施する。
  // ====================================================================================================
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      // bfcache 復帰: フォーム値・属性・JS closure はブラウザが完全復元済み
      // → updateNoshiOptions / toggleAdditionalName は呼ばない（呼ぶと復元値を破壊する）
      // → delivery_time 再同期と validateAll だけ走らせる
      scheduleUpdateNoshiSummary({ immediate: true });
      validateAll();
      return;
    }

    // 非 bfcache pageshow（通常は DOMContentLoaded で初期化済みなので稀ケース）:
    // 念のため従来通りの再初期化を実施
    updateNoshiOptions();
    scheduleUpdateNoshiSummary({ immediate: true });
    validateAll();

    if (noshiName.value.includes('記名あり')) {
      if (addButtonWrapper) addButtonWrapper.style.display = 'block';
    } else {
      if (addButtonWrapper) addButtonWrapper.style.display = 'none';
      toggleAdditionalName(false);
    }

    // [FIX P0-5 / v13.3] 念のため pageshow でも連名復元
    // (DOMContentLoaded が走らないバックフォワードキャッシュ無効な特殊ケースを保護)
    restoreAdditionalNameFromCart();
  });
});

// judge.me Reviewのテキスト書き換え
// ==================================================================================================== //
(function () {
  var PATCHES = [
    { sel: '.jdgm-write-review-modal__checkbox-text',
      text: 'ニックネームは掲載せず「匿名希望」として投稿する' },

    { sel: '#jdgm-name-help',
      text: '※ご入力いただいたニックネームはサイト上には掲載されません。' },

    { sel: '.jdgm-write-review-modal__gdpr-statement',
      html: 'ご記入いただいたレビューについて、必要な場合にのみご連絡させていただく場合がございます。<br>'
          + 'レビューを送信することで、当レビューシステム「Judge.me」の'
          + '<a href="https://judge.me/terms" target="_blank" rel="nofollow noopener">利用規約</a>、'
          + '<a href="https://judge.me/privacy" target="_blank" rel="nofollow noopener">プライバシーポリシー</a>、'
          + '<a href="https://judge.me/content-policy" target="_blank" rel="nofollow noopener">コンテンツポリシー</a>及び'
          + '当サイトの<a href="/policies/terms-of-service" target="_blank" rel="nofollow noopener">利用規約</a>、'
          + '<a href="/policies/privacy-policy" target="_blank" rel="nofollow noopener">プライバシーポリシー</a>'
          + 'に同意したことになります。' }
  ];

  function norm(s) { return s.replace(/\s+/g, ' ').trim(); }

  function apply() {
    PATCHES.forEach(function (p) {
      document.querySelectorAll(p.sel).forEach(function (el) {
        if (p.html != null) {
          if (norm(el.innerHTML) === norm(p.html)) return;  // 適用済み
          el.innerHTML = p.html;
        } else {
          if (norm(el.textContent) === norm(p.text)) return;
          el.textContent = p.text;
        }
      });
    });
  }

  apply();
  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
})();
/* document.addEventListener("DOMContentLoaded", function () {
  setInterval(() => {
    // 送信ボタン
    const sharePage = document.querySelector(
      ".jdgm-write-review-modal__page--share-media.current-page",
    );
    const nextBtn = document.querySelector(
      ".jdgm-write-review-modal__nav-btn.jdgm-write-review-modal__nav-btn-next",
    );

    if (nextBtn) {
      if (sharePage) {
        nextBtn.textContent = "送信する";
      } else {
        nextBtn.textContent = "次へ";
      }
    }
  }, 1000);
}); */